import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TClipDeclaration, TPostClipDeclaration } from '../types';

export async function postClipDeclaration(body: TPostClipDeclaration): Promise<TClipDeclaration> {
  return mediaManagerClient.post('/api/v1/clip_declarations', emptyStringValues(body));
}

type MutationFn = typeof postClipDeclaration;

type TUsePostClipDeclaration = {
  config?: MutationConfig<MutationFn>;
  invalidateClipQueries?: boolean;
};

type TPostClipDeclarationSilently = TPostClipDeclaration & { silently?: boolean };

export function usePostClipDeclaration({
  config = {},
  invalidateClipQueries = false,
}: TUsePostClipDeclaration = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: ({ silently = false, ...body }: TPostClipDeclarationSilently) =>
      postClipDeclaration({ ...(body as TPostClipDeclaration), silently }),
    onError(error) {
      addErrorNotification(t('No se ha podido crear la declaración del corte'));
      console.error(error);
    },
    onSuccess(_data, variables: TPostClipDeclarationSilently) {
      if (!variables.silently) {
        addSuccessNotification(t('La declaración del corte se ha creado correctamente'));
      }
      if (invalidateClipQueries) {
        queryClient.invalidateQueries({ queryKey: ['clips'] });
      }
    },
  });
}
